// import { io } from "socket.io-client";

// const BASE_URL = "https://evamobileservices.azurewebsites.net"
// const BASE_URL_DEV = "http://192.168.0.160:4000"
// const socket = io.connect(BASE_URL);
// export default socket;


import { io } from "socket.io-client";

const BASE_URL = "https://evamobileservices.azurewebsites.net:4000"
// const BASE_URL = "http://192.168.100.60:4000"
const BASE_URL_DEV = "http://192.168.0.160:4000"
// const socket = io.connect(BASE_URL);
// const socket = io("https://evamobileservices.azurewebsites.net", {
  // const socketServer = io("http://192.168.1.15:4000", {
const socketServer = io("https://evamobileservices.azurewebsites.net", {
  reconnection: true,
  reconnectionAttempts: Infinity, // Keep trying to reconnect
  reconnectionDelay: 1000,        // Start with 1 second delay
  reconnectionDelayMax: 10000,    // Max delay of 10 seconds
  timeout: 20000,
  withCredentials: true,
  transports: ["websocket"], // avoid polling
  autoConnect: false,        // this must match usage below
  forceNew: true,           // Force new connection
  upgrade: true,            // Allow transport upgrade
  rememberUpgrade: true,    // Remember transport upgrade
  maxReconnectionAttempts: 10, // Maximum attempts before giving up
  randomizationFactor: 0.5, // Add randomness to reconnection delays
});

// Connection state management
let connectionState = {
  isConnected: false,
  isConnecting: false,
  reconnectAttempts: 0,
  lastReconnectAttempt: null,
  connectionError: null
};

// Event listeners for connection state management
socketServer.on('connect', () => {
  console.log('✅ Socket.IO connected successfully');
  connectionState.isConnected = true;
  connectionState.isConnecting = false;
  connectionState.reconnectAttempts = 0;
  connectionState.connectionError = null;
  
  // Emit custom event for connection state change
  socketServer.emit('connectionStateChanged', { 
    status: 'connected', 
    timestamp: new Date().toISOString() 
  });
});

socketServer.on('disconnect', (reason) => {
  console.log('❌ Socket.IO disconnected:', reason);
  connectionState.isConnected = false;
  connectionState.isConnecting = false;
  
  // Handle different disconnect reasons
  if (reason === 'io server disconnect') {
    // Server initiated disconnect, try to reconnect
    console.log('🔄 Server disconnected, attempting to reconnect...');
    socketServer.connect();
  } else if (reason === 'io client disconnect') {
    // Client initiated disconnect, don't auto-reconnect
    console.log('👤 Client disconnected intentionally');
  } else {
    // Network issues, will auto-reconnect
    console.log('🌐 Network disconnect, auto-reconnecting...');
  }
});

socketServer.on('connect_error', (error) => {
  console.error('🚨 Socket.IO connection error:', error);
  connectionState.isConnecting = false;
  connectionState.connectionError = error.message;
  
  // Log specific error types
  if (error.message.includes('timeout')) {
    console.log('⏰ Connection timeout, retrying...');
  } else if (error.message.includes('xhr poll error')) {
    console.log('🌐 Network error, retrying...');
  }
});

socketServer.on('reconnect', (attemptNumber) => {
  console.log(`🔄 Socket.IO reconnected after ${attemptNumber} attempts`);
  connectionState.isConnected = true;
  connectionState.isConnecting = false;
  connectionState.reconnectAttempts = 0;
  connectionState.connectionError = null;
  
  // Re-join any necessary rooms or re-authenticate
  socketServer.emit('reconnected', { 
    attemptNumber, 
    timestamp: new Date().toISOString() 
  });
});

socketServer.on('reconnect_attempt', (attemptNumber) => {
  console.log(`🔄 Socket.IO reconnection attempt ${attemptNumber}`);
  connectionState.isConnecting = true;
  connectionState.reconnectAttempts = attemptNumber;
  connectionState.lastReconnectAttempt = new Date().toISOString();
});

socketServer.on('reconnect_error', (error) => {
  console.error('🚨 Socket.IO reconnection error:', error);
  connectionState.connectionError = error.message;
});

socketServer.on('reconnect_failed', () => {
  console.error('💥 Socket.IO reconnection failed after all attempts');
  connectionState.isConnected = false;
  connectionState.isConnecting = false;
  connectionState.connectionError = 'Reconnection failed after all attempts';
  
  // Optionally show user notification or trigger manual reconnect
  if (typeof window !== 'undefined') {
    // You can dispatch a custom event to notify the UI
    window.dispatchEvent(new CustomEvent('socketReconnectionFailed'));
  }
});

// Utility functions for socket management
export const getConnectionState = () => ({ ...connectionState });

export const forceReconnect = () => {
  console.log('🔄 Force reconnecting socket...');
  socketServer.disconnect();
  setTimeout(() => {
    socketServer.connect();
  }, 1000);
};

export const disconnectSocket = () => {
  console.log('👤 Manually disconnecting socket...');
  socketServer.disconnect();
};

// Enhanced emit function with retry logic
export const emitWithRetry = (event, data, maxRetries = 3) => {
  return new Promise((resolve, reject) => {
    let retryCount = 0;
    
    const attemptEmit = () => {
      if (!socketServer.connected) {
        if (retryCount < maxRetries) {
          retryCount++;
          console.log(`🔄 Socket not connected, retrying emit (${retryCount}/${maxRetries})...`);
          setTimeout(attemptEmit, 1000 * retryCount);
        } else {
          reject(new Error('Socket not connected after max retries'));
        }
        return;
      }
      
      socketServer.emit(event, data, (response) => {
        if (response && response.error) {
          reject(new Error(response.error));
        } else {
          resolve(response);
        }
      });
    };
    
    attemptEmit();
  });
};

export default socketServer;
